// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Post_wrapper__vTYwJ","title":"Post_title__2oPIP","edit":"Post_edit__fYjGF","date":"Post_date__36YID","delete":"Post_delete__2ecn5"};